"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("models").service("VehiclesService", ["$rootScope", "Logger", "ApiService", "CustomListsService", function ($rootScope, Logger, ApiService, CustomListsService) {
  var log = Logger.getInstance("VehiclesService");

  var that = this;

  var params = {
    name: "vehicles",
    attributesForCache: ["plateNumber", "label", "insurerContract", "toCheck", "type"],

    formatName: function formatName(element) {
      return that.getName(element);
    }
    //defaultOrder: {date: -1},
  };

  angular.extend(that, ApiService.getModelBis(params));

  that.getName = function (o) {
    if (o) {
      if (o.error === 404 && !["super-admin", "super-operator", "operator", "user-admin", "hr"].includes($rootScope.$user.role)) {
        return "Masqué (hors périmètre)";
      } else if (o.error === 404) {
        return "Supprimé";
      }
      return (o.plateNumber ? o.plateNumber : "") + (o.label ? " ( " + o.label + " ) " : "");
    } else {
      return "???";
    }
  };

  that.remoteSelectArray = function () {
    var _this = this;

    console.log("call remoteSelectArray vehicle for " + $rootScope.$selectedCustomerId);

    return new Promise(function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
        var typeVehicles, remote, list;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return CustomListsService.getSelectArray("typeVehicleV2");

              case 2:
                typeVehicles = _context2.sent;

                typeVehicles = typeVehicles.map(function (item) {
                  return { value: item.value, name: item.name.split(" (")[0] };
                });

                _context2.next = 6;
                return that.customPost("selectArray", {
                  customerId: $rootScope.$selectedCustomerId
                });

              case 6:
                remote = _context2.sent;

                if (!(remote.success == true)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 10;
                return Promise.all(remote.data.map(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(vehicle) {
                    var typeVehicleName, typeOfVehicleData, active;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            typeVehicleName = "";
                            typeOfVehicleData = typeVehicles.find(function (item) {
                              return vehicle.type === item.value;
                            });

                            if (typeOfVehicleData) {
                              typeVehicleName = typeOfVehicleData.name;
                            }
                            active = !vehicle.outDate || new Date(vehicle.outDate) >= new Date() ? true : false;
                            return _context.abrupt("return", {
                              name: String(vehicle.plateNumber) + (!active ? " <sorti de l'entreprise>" : "") + (vehicle.label ? " (" + vehicle.label + ")" : "") + (typeVehicleName ? " [" + typeVehicleName + "] " : ""),
                              value: "$" + vehicle._id
                            });

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 10:
                list = _context2.sent;


                list = list.sort(function (a, b) {
                  if (a.name) {
                    if (b.name) {
                      return a.name.localeCompare(b.name);
                    } else {
                      1;
                    }
                  } else {
                    return -1;
                  }
                });

                list.unshift({
                  name: "A PRECISER OU NON TROUVE",
                  value: null
                });

                console.log("list vehicles", list);

                resolve(list);
                _context2.next = 18;
                break;

              case 17:
                reject(remote.error);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
}]);